// removed by extract-text-webpack-plugin
module.exports = {"flipContainer":"_3zkSe","flipContainer_flipped":"_1gMXs _3zkSe","card_back":"_38pty _3y0_I","card_front":"oXyPl _3y0_I","flipper":"_15cEu","card":"_3y0_I","content":"_2GZ--","content_front":"_14-Fq _2GZ--","content_back":"_1QU_t _2GZ--","baseStyle":"_3VHY7","wrapper_default":"wZREs _3VHY7","wrapper_card":"qp-mN","wrapper_filmis":"_2qQGb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Flipper/styles.scss
 ** module id = 453
 ** module chunks = 0
 **/